// extracted by mini-css-extract-plugin
export default {"root":"HeaderAddress_root__dmBKL","selected":"HeaderAddress_selected__UchEz"};